'use client'

import { cn } from '@/lib/utils'

interface FluxLogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl'
  showText?: boolean
  className?: string
}

const sizes = {
  sm: { icon: 'w-7 h-7', text: 'text-base', gap: 'gap-1.5' },
  md: { icon: 'w-9 h-9', text: 'text-lg', gap: 'gap-2' },
  lg: { icon: 'w-10 h-10', text: 'text-xl', gap: 'gap-2' },
  xl: { icon: 'w-12 h-12', text: 'text-2xl', gap: 'gap-2.5' },
}

export function FluxLogo({ size = 'md', showText = true, className }: FluxLogoProps) {
  const s = sizes[size]

  return (
    <div className={cn('flex items-center', s.gap, className)}>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src="/favicon.svg"
        alt="FluxPay"
        className={cn(s.icon, 'flex-shrink-0')}
      />
      {showText && (
        <>
          {/* Dark mode: light gradient text */}
          <span
            className={cn(
              'font-semibold tracking-wide uppercase hidden dark:inline',
              s.text
            )}
            style={{
              background: 'linear-gradient(135deg, #e0f4ff 0%, #ffffff 25%, #b0d8ff 50%, #ffffff 75%, #90b0e0 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}
          >
            FluxPay
          </span>
          {/* Light mode: dark gradient text */}
          <span
            className={cn(
              'font-semibold tracking-wide uppercase inline dark:hidden',
              s.text
            )}
            style={{
              background: 'linear-gradient(135deg, #0e7490 0%, #155e75 25%, #1D3557 50%, #0891b2 75%, #164e63 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}
          >
            FluxPay
          </span>
        </>
      )}
    </div>
  )
}
